// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"TA","carousel__wrapper_on_sides":"UA","arrows_wrapper":"VA","arrows_wrapper_right":"WA","arrows_wrapper_vertical":"XA","arrows_wrapper_on_sides":"YA","arrow_button":"ZA","carousel_arrow_left":"aB","carousel_arrow_left_on_side":"bB","carousel_arrow_right_on_side":"cB","carousel_arrow":"eB","arrows_wrapper_rounded":"fB","carousel__fullWidth":"gB"};
    if(module.hot) {
      // 1715276856503
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  